import CoinPng from "./coin.png";
export const ImageFiles = {
  CoinPng: CoinPng,
};
